import psychologyConsultationClient from '@/axiosClients/psychologyConsultationClient';
import resilienceConsultationClient from '@/axiosClients/resilienceConsultationClient';

const getResume = (data) => {
    return psychologyConsultationClient.post(`/checkout`, data);
}

const setPaymentProcess = (data) => {
    return psychologyConsultationClient.post(`/checkout/set-payment-processed`, data);
}

const getScheduledSessions = () => {
    return psychologyConsultationClient.get(`/scheduled-sessions/waiting-room`)
}

const getScheduledSessionsTPTFlow = () => {
    return psychologyConsultationClient.get(`/scheduled-sessions/waiting-room/tpt`)
}

const getScheduledSessionsBalintFlow = () => {
    return psychologyConsultationClient.get(`/scheduled-sessions/waiting-room/balint`)
}

const setPsychologyEvaluation = (data) => psychologyConsultationClient.post(`/psychology-evaluation`, data);

const getPsychologyEvaluation = (consultationId) => {
    return psychologyConsultationClient.get(`/psychology-evaluation/${consultationId}`);
}

const updatePsychologistConsultation = (data) => {
    return psychologyConsultationClient.post(`/change-date/${data.consultationId}`, data);
}

const getCards = () => {
    return psychologyConsultationClient.get(`/checkout/cards`)
}

const setCardToCustomer = (data) => {
    return psychologyConsultationClient.post(`/checkout/attach-payment-method`, data)
}

const deleteCard = (cardId) => {
    return psychologyConsultationClient.delete(`/checkout/card/${cardId}`)
}

const addMinutesToPenddingPayment = (data) => {
    return psychologyConsultationClient.post(`/checkout/add-minutes-payment-pending`, data)
}

const getPatientsOfPsychologist = (userId) => {
    return psychologyConsultationClient.get(`/consultations/billing/get-patients-of-psychologist/${userId}`);
}

const getExcelConsultationForPay = (data) => {
    return psychologyConsultationClient.get(`/consultations/for-pay/export${data.filtersString}`, {
        responseType: 'blob'
    });
}

const setPayPsychologistSessions = (sessions) => {
    return psychologyConsultationClient.post(`/consultations/set-paid`, sessions)
}

const generateCFDISessions = (sessions) => {
    return psychologyConsultationClient.post(`/consultations/generateCFDI`, sessions)
}

const getXmlOrPdfDownload = (data) => {
    return psychologyConsultationClient.get(`/consultations/download/${data.type}/invoice/${data.invoiceId}`, {
        responseType: 'blob'
    });
}

const getDownloadCFDIBody = (data) => {
    return psychologyConsultationClient.post(`/consultations/downloadCFDIBody`, data, {
        responseType: 'blob'
    });
}

const checkoutRecurrency = (data) => {
    return psychologyConsultationClient.post(`/checkout/recurrency`, data)

}
const setDefaultPaymentCard = (data) => {
    return psychologyConsultationClient.post(`/checkout/default-card/${data.userId}`, {card_id: data.cardId})
}

const generateCharge = (data) => {
    return psychologyConsultationClient.post(`/checkout/generate-charge`, data)
}

const applyDiscountCode = (data) => {
    return psychologyConsultationClient.post(`/checkout/apply-discount-code`, data)
}

const calculateTotalApplyCardMimente = (data) => {
    return psychologyConsultationClient.post(`/checkout/calculate-total/apply-discount-card`, data)
}

const cancelConsultation = (data) => {
    return psychologyConsultationClient.post(`/consultations/cancel-session`, data)
}

const cancelResilienceSession = (data) => {
    return resilienceConsultationClient.post(`/consultation/cancel-session`, data)
}

const getExcelCanceledSessions = (data) => {
    return psychologyConsultationClient.get(`/consultations/cancelled/export`, {
        responseType: 'blob'
    });
}

const updatePsychologistEvaluationNotes = (data) => psychologyConsultationClient.post(`/psychology-evaluation/${data.noteId}`, data);

const addPatientToWaitingList = (data) => psychologyConsultationClient.post(`/waiting-list/add-user`, data);

const removePatientFromWaitingList = (data) => psychologyConsultationClient.post(`/waiting-list/remove-user`, data);

const getModalFormEvaluation = (roomName = null) => {
    const endpoint = roomName ? `/evaluation/${roomName}` : '/evaluation';
    return psychologyConsultationClient.get(endpoint);
}

const saveModalFormEvaluation = (data) => {
    return psychologyConsultationClient.post(`/evaluation`, data);
}

const generateDyteToken = (roomName) => {
    return psychologyConsultationClient.post(`/dyte/create-participant-token`, {room_name: roomName});
}

const getCarouselData = () => {
    return psychologyConsultationClient.get(`/carousel`);
}

const getCommunicationChannels = () => {
    return psychologyConsultationClient.get(`/patient-attendance/communication-channels`);
}

const updatePatientAttendance = (consultationId, data) => {
    return psychologyConsultationClient.put(`/patient-attendance/update-attendance/${consultationId}`, data);
}

const updateReferralConsultation = (consultationId, data) => {
    return psychologyConsultationClient.put(`/referral-consultation/update/${consultationId}`, data);
}

export default {
    deleteCard,
    setCardToCustomer,
    getCards,
    getResume,
    setPaymentProcess,
    getScheduledSessions,
    setPsychologyEvaluation,
    getPsychologyEvaluation,
    generateDyteToken,
    updatePsychologistConsultation,
    addMinutesToPenddingPayment,
    getScheduledSessionsTPTFlow,
    getScheduledSessionsBalintFlow,
    getPatientsOfPsychologist,
    getExcelConsultationForPay,
    setPayPsychologistSessions,
    generateCFDISessions,
    getXmlOrPdfDownload,
    getDownloadCFDIBody,
    checkoutRecurrency,
    setDefaultPaymentCard,
    generateCharge,
    applyDiscountCode,
    calculateTotalApplyCardMimente,
    cancelConsultation,
    getExcelCanceledSessions,
    updatePsychologistEvaluationNotes,
    addPatientToWaitingList,
    removePatientFromWaitingList,
    getModalFormEvaluation,
    saveModalFormEvaluation,
    getCarouselData,
    getCommunicationChannels,
    updatePatientAttendance,
    updateReferralConsultation,
    cancelResilienceSession
}
